import { uuidv4 } from '@/utils/helpers';
import { axiosErrorWrapper } from '@/utils/axios.util';
import axios from 'axios';
import arobaAxiosInstance from '../axios/aroba-axios.service';

// import store from '@/store'
const baseDomain = process.env.VUE_APP_API_BASE_URL;
// const appMode = process.env.VUE_APP_MODE

const options = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const requestsController = new Map();
const registeredRequests = new Map();

/**
 * Http GET
 */
export async function get(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const controller = new AbortController();
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      value.forEach((val) => {
        searchParams.append(key, val);
      });
    } else if (value !== null) {
      searchParams.append(key, value);
    }
  }
  const newOptions = {
    ...options,
    signal: controller.signal,
    params: searchParams,
  };

  if (params.__headers) {
    newOptions.headers = { ...newOptions.headers, ...params.__headers };
  }

  try {
    let requestURL = `${baseDomain}${url}`;
    if (url.startsWith('http')) {
      requestURL = `${url}`;
    }

    // set request controll if request id exist
    if (params.__reqId) {
      requestsController.set(params.__reqId, controller);
    }
    // call http request
    const result = await arobaAxiosInstance.get(requestURL, newOptions);

    // delete request controller if request id exist
    if (params.__reqId) {
      requestsController.delete(params.__reqId);
    }
    return result.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      const obj = {};
      Object.setPrototypeOf(obj, { _isCancel: true });
      return obj;
    }
    throw axiosErrorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http POST
 */
export async function post(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const controller = new AbortController();

  const newOptions = {
    signal: controller.signal,
    ...options,
  };

  try {
    let requestURL = `${baseDomain}${url}`;
    if (url.startsWith('http')) {
      requestURL = `${url}`;
    }

    // set request controll if request id exist
    if (params.__reqId) {
      requestsController.set(params.__reqId, controller);
    }

    // call http request
    const result = await arobaAxiosInstance.post(
      requestURL,
      params,
      newOptions
    );

    // delete request controller if request id exist
    if (params.__reqId) {
      requestsController.delete(params.__reqId);
    }

    return result.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      const obj = {};
      Object.setPrototypeOf(obj, { _isCancel: true });
      return obj;
    }
    throw axiosErrorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http PUT
 */
export async function put(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const newOptions = {
    ...options,
  };

  try {
    let requestURL = `${baseDomain}${url}`;
    if (url.startsWith('http')) {
      requestURL = `${url}`;
    }
    const result = await arobaAxiosInstance.put(requestURL, params, newOptions);
    return result.data;
  } catch (error) {
    throw axiosErrorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http DELETE
 */
export async function del(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const newOptions = {
    ...options,
    data: params,
  };

  try {
    let requestURL = `${baseDomain}${url}`;
    if (url.startsWith('http')) {
      requestURL = `${url}`;
    }

    const result = await arobaAxiosInstance.delete(requestURL, newOptions);
    return result.data;
  } catch (error) {
    throw axiosErrorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Abort http request
 * @param {string} reqId
 */
export const abortRequest = (reqId) => {
  if (requestsController.has(reqId)) {
    const controller = requestsController.get(reqId);
    controller.abort();
    requestsController.delete(reqId);
  }
};

/**
 * Register http request using API name
 * @param {string} apiName
 * @param {*} payload
 */
export const registerHttpRequest = (apiName, payload, duplicate) => {
  const reqId = uuidv4();
  // prevent duplicate request
  if (registeredRequests.has(apiName) && !duplicate) {
    const oldReqId = registeredRequests.get(apiName);
    abortRequest(oldReqId);
  }
  registeredRequests.set(apiName, reqId);
  Object.setPrototypeOf(payload, { __reqId: reqId });
  return {
    reqId,
  };
};
